"use client";

import React, { useEffect, useState } from "react";
import { CheckboxGroup, Label } from "react-aria-components";
import { Checkbox, Text } from "ui-components";

export interface IInterestedInBecomingProps {
  label?: string;
  isRequired?: boolean;
  selectInterestedInBecoming?: string;
  onInterestedInBecomingChange?: (selectInterestedInBecoming: string) => void;
  errorMessage?: string;
}

export function InterestedInBecoming({
  label,
  isRequired,
  selectInterestedInBecoming = "",
  onInterestedInBecomingChange,
  errorMessage,
}: IInterestedInBecomingProps): JSX.Element {
  const [selected, setSelected] = useState<string[]>(
    selectInterestedInBecoming ? selectInterestedInBecoming.split(",") : []
  );

  useEffect(() => {
    setSelected(
      selectInterestedInBecoming ? selectInterestedInBecoming.split(",") : []
    );
  }, [selectInterestedInBecoming]);

  function handleSelectInterestedInBecoming(value: string[]): void {
    setSelected(value);
    onInterestedInBecomingChange?.(value.join(","));
  }

  return (
    <CheckboxGroup
      className="flex flex-col gap-4"
      value={selected}
      onChange={(value) => handleSelectInterestedInBecoming(value)}
    >
      <Label>
        <Text variant="small" align="left">
          {label}
          {isRequired && (
            <Text
              variant="small"
              intent="secondary"
              className="ml-1"
              align="left"
            >
              (required)
            </Text>
          )}
        </Text>
      </Label>
      <div className="flex flex-row flex-wrap gap-4">
        <Checkbox value="Attendee" label="Attendee" />
        <Checkbox value="Main Sponsor" label="Main Sponsor" />
        <Checkbox value="Day Sponsor" label="Day Sponsor" />
        <Checkbox value="Session Sponsor" label="Session Sponsor" />
        <Checkbox value="Speaker" label="Speaker" />
      </div>
      {errorMessage && (
        <Text variant="small" intent="danger">
          {errorMessage}
        </Text>
      )}
    </CheckboxGroup>
  );
}
